import TemplateDetailRoute from '@/features/data/templates/components/TemplateDetailRoute.tsx';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/data/templates/$templateId')({
  component: TemplateDetailRoute,
});
